import { useContext, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

//! User Files

import App from "app/App";
import { AppContext } from "AppContext";
import { ROUTES } from "common/constants";
import Login from "modules/auth/Login";
import Logout from "modules/auth/components/Logout";
import GoogleAuthCode from "modules/auth/GoogleAuthCode";
import PrivateRoute from "./PrivateRoute";

const Routes = () => {
  const { initializeAuth } = useContext(AppContext);

  useEffect(() => {
    initializeAuth();
    // eslint-disable-next-line
  }, []);

  return (
    <Router>
      <Switch>
        <Route exact path={ROUTES.LOGIN} component={Login} />
        <Route exact path={ROUTES.LOGOUT} component={Logout} />
        <Route exact path={ROUTES.GAUTH} component={GoogleAuthCode} />
        <PrivateRoute path="/" component={App} />
      </Switch>
    </Router>
  );
};
export default Routes;
